/** configuration screen headers text */
export const CONFIG_HEADERS_CONSTANTS = {
  NAME_OF_THE_CLIENT: "NAME OF THE CLIENT",
  SAMPLE_DATA: "SAMPLE DATA FILE UPLOAD",
  ENTRY_POINTS: "ENTRY POINTS",
  ENTRY_POINTS_GROUP: "ENTRY POINTS GROUPING",
  MANDATORY_VARIABLES: "MANDATORY VARIABLES MAPPING",
  DIMENSION: "DIMENSION",
  AGGREGATED_MARKET_GROUP: "CUSTOM ENTRY POINTS",
  CUSTOM_LOGO: "CUSTOM LOGO",
  NESTING: "NESTING",
  SAVE_SELECTION: "SAVE SELECTION",
  FILTER_FUNCTION: "FILTER FUNCTION",
  WEIGHTS: "WEIGHTS",
  OUTPUT_PAGE: "OUTPUT PAGE",
  SIGNIFICANCE_TESTING: "SIGNIFICANCE TESTING",
  COMPARISION_POINTS: "COMPARISION POINTS",
  TYPEOF_SIGNIFICANCE: "TYPE OF SIGNIFICANCE",
  MULTIPLE_CONFIDENCE_LEVELS: "MULTIPLE CONFIDENCE LEVELS",
  EXPORTS_DOWNLOADS: "EXPORTS DOWNLOADS",
  LOW_BASE_IDENTIFIER: "LOW BASE IDENTIFIER",
  DOCUMENTS: "DOCUMENTS REPOSITORY",
  HELP_GUIDE: "Help Guide",
  CUSTOM_GROUPS: "CUSTOM GROUPS",
  CUSTOMS_CALCULATIONS: "CUSTOMS CALCULATIONS",
  CUSTOMS_REPORT: "CUSTOMS REPORT",
  USER_MANAGEMENT: "USER MANAGEMENT",
  THRESHOLD_IDENTIFIER: "INDEX THRESHOLD",
  CUSTOM_CONTENT: "CUSTOM CONTENT",
  MODULES: "MODULES",
  DATA_FORMAT: "DATA FORMAT",
  MANDATORY_VARIABLES_DATA: "MANDATORY VARIABLES",
  COLOR_PALETTE:"COLOUR PALETTE",
  ADDITIONAL_FEATURES:"ADDITIONAL FEATURES ACROSS MODULES",
  WEIGHT_COMPARISON: "WEIGHT COMPARISON",
  CUSTOM_REPORTS_EXCEL_COLOURS: "CUSTOM REPORTS EXCEL COLOURS"
}
/** configuration screen button text constants */
export const CONFIG_BUTTONS_NAMES = {
  SAMPLE_FILE_UPLOAD: "Upload",
  SAMPLE_FILE_PREVIEW: "Preview",
  LOGO_UPLOAD: "Upload",
  LOGO_PREVIEW: "Preview",
  COLOR_PALETTE_DOWNLOAD:"Download Template",
  COLOR_PALETTE_UPLOAD:"Upload",
  COLOR_PALETTE_EXISTING:"Download",
  SUBMIT: "Submit",
  SAVE: "Save",
  CLEAR_ALL: "Reset",
  DOCUMENT_SAVE: "Save",
  DOCUMENT_UPLOAD: "Upload",
  DOCUMENT_DELETE: "Delete",


}
/** configuration screen other static texts */
export const CONFIG_OTHER_NAMES = {
  CLIENT_NAME_LABEL: "Client Name",
  STUDY_NAME_LABEL: "Study Name",
  NESTING_DROPDOWN_VALUE1: "2*2",
  NESTING_DROPDOWN_VALUE2: "N*N",
  SAMPLE_FILE_ALLOWED_FORMAT: ".xls,.csv",
  SAMPLE_FILE_FORMAT: "*File format supported: .xls/.csv",
  LOGO_FILE_ALLOWED_FORMAT: ".jpeg,.png,.svg,.zip",
  COLOR_FILE_ALLOWED_FORMAT: ".xlsx",
  LOGO_FILE_FORMAT: "*File format supported: .jpeg/.png/.svg/.zip",
  COLOR_PALETTE_NOTE:"*For custom palette, please download the default Color Palette file, edit it and upload it.",
  SIGNIFICANCE_HEADER: "SIGNIFICANCE TESTING",
  YES: "Yes",
  NO: "No",
  RESET_SELECTION: "Reset Selection",
  CHART_VISUAL: "Chart Visualization(Fixed Chart Library)",
  BRAND_ANALYSIS: "Brand Analysis",
  STICKY_SELECTION: "Sticky Selection",
  DISTINCT: "Distinct",
  STATIC_TXT_DISPLAY: "Static text display",
  TOOLTIP_DISPLAY_FOM: "Tooltip display from FOM",
  DOCUMENT_ITEM1_LABEL1: "Folder",
  DOCUMENT_ITEM1_LABEL2: "New Folder",
  DOCUMENT_ITEM2_LABEL1: "File",
  DOCUMENT_ITEM2_LABEL2: "New File",
  FOLDER_SELECTED_DEFAULT_VAL: "Select Folder",
  FILE_SELECTED_DEFAULT_VAL: "Select File",
  STORYBOARD: "Story Board",
  AI_INTEGRATION: "AI Integration",
  COLUMN_ROW_PERCENTAGE: "Column/Row Percentage",
  SELECT_ALL_METRICS: "Select All Metrics",
  TIME_PERIOD_FACTOR_TPF: "Time Period Factor (TPF)",
  CROSSTAB: "Crosstab (CT)",
  BRAND_ANALYSIS_BA: "Brand Analysis (BA)",
  SNAPSHOT: "Snapshot"
}

export const MESSAGE_TEXT = {
  CLIENT_NAME: "Client Name is required",
  STUDY_NAME: "Study Name is required",
  WEIGHT_INPUT: "Please fill the selected Weights",
  VARIABLE_MAPPING: "Please fill all the Mandatory Variable Mappings",
  MODULE_NAME_ClientTab: "Please select Module Names",
  MODULE_NAME_StudyTab: "Please select Module Names from Study Configuration Tab",
  DATA_FORMAT_ClientTab: "Please select Data Format",
  DATA_FORMAT_StudyTab: "Please select Data Format from Client Details Tab",
}

export const FOLDER_LIST = [
  "Questionnaire",
  "Data Schedule",
  "Data Availability",
  "Data Mapping Files",
  "Help Documents",
  "Survey Information",
  "Sample Files",
  "Planning Documents",
  "Status Reports",
  "Usage Reports",
  "Change Logs",
  "Other Documents",
  "Other Documents 2",
  "Other Documents 3"
]
